module.exports = __webpack_public_path__ + "static/media/1-tod-list-thumb.cb08d8ef.png";